module.exports = __webpack_public_path__ + "img/zh.406844d2.svg";